/* eslint-disable no-param-reassign */
const finishPlatingParameter = (parameters, name, value) => {
  const current = parameters.finish_plating;
  if (current !== 'Lead Free Solder' && current !== 'ENIG' && current !== 'Immersion Silver') {
    if (value === 'Lead Free Solder' || value === 'ENIG' || value === 'Immersion Silver') {
      if (parameters.material_type !== 'FR4TG180') {
        parameters.material_type = 'FR4TG180';
        vfShowModalInformation('Since you selected a RoHS finish we automatically upgraded the material to FR4 Tg180. We recommend using FR4 Tg180 with RoHS finish.<br><br>You can change the Material back to FR4 Tg135 if you wish.', '#modal-form-messages');
      }
    }
  }
};

const railsParameters = (parameters, name, value) => {
  if (name === 'add_rails_left_right') {
    if (value === '1') {
      parameters.rails_left = '0.5';
      parameters.rails_right = '0.5';
    } else {
      parameters.rails_left = '';
      parameters.rails_right = '';
    }
  } else if (name === 'add_rails_top_bottom') {
    if (value === '1') {
      parameters.rails_top = '0.5';
      parameters.rails_bottom = '0.5';
    } else {
      parameters.rails_top = '';
      parameters.rails_bottom = '';
    }
  }
};

const tabRoutePanelsParameter = (parameters, name, value) => {
  parameters.has_array = '1';
  parameters.scoring = '0';
  parameters.tab_rout = '1';
  parameters.array_spacing_x = parameters.array_spacing_x_tab_rout;
  parameters.array_spacing_y = parameters.array_spacing_y_tab_rout;
}

const vScorePanelsParameter = (parameters, name, value) => {
  parameters.has_array = '1';
  parameters.scoring = '1';
  parameters.tab_rout = '0';

  parameters.array_spacing_x = parameters.array_spacing_x_vscore;
  parameters.array_spacing_y = parameters.array_spacing_y_vscore;
}

const numCounterBoreHoles = (parameters, name, value) => {
  // whx calculate counter bores only accept 1 or 0
  if (name === 'number_of_counterbore_holes') {
    parameters.counterbores = (parseInt(value, 10) > 0 ? '1' : '0');
  }
  parameters[name] = value;
};

const numCountersinkHoles = (parameters, name, value) => {
  // whx calculate countersinks only accept 1 or 0
  parameters.countersinks = (parseInt(value, 10) > 0 ? '1' : '0');
  parameters[name] = value;
};

const materialTypeFinishPlatingParameter = (parameters, name, value) => {
  const values = _.split(value, '/')
  parameters[name] = value;
  parameters.material_type = values[0];
  parameters.finish_plating = values[1];

};

export const changeParameterByName = (parameters, name, value) => {
  switch (name) {
    case 'finish_plating':
      finishPlatingParameter(parameters, name, value);
      break;
    case 'add_rails_left_right':
    case 'add_rails_top_bottom':
      railsParameters(parameters, name, value);
      break;
    case 'tab_route_panels':
      tabRoutePanelsParameter(parameters, name, value);
      break;
    case 'v_score_panels':
      vScorePanelsParameter(parameters, name, value);
      break;
    case 'number_of_counterbore_holes':
      numCounterBoreHoles(parameters, name, value);
      break;
    case 'number_of_countersink_holes':
      numCountersinkHoles(parameters, name, value);
      break;
    case 'material_type_finish_plating':
      materialTypeFinishPlatingParameter(parameters, name, value);
      break;
    case 'qty1':
      parameters.quantities[0] = value;
      break;
    case 'qty2':
      parameters.quantities[1] = value;
      break;
    case 'qty3':
      parameters.quantities[2] = value;
      break;
    case 'qty4':
      parameters.quantities[3] = value;
      break;
    case 'array_spacing_x_tab_rout':
    case 'array_spacing_x_vscore':
      parameters.array_spacing_x = value
      parameters[name] = value;
      break;
    case 'array_spacing_y_tab_rout':
    case 'array_spacing_y_vscore':
      parameters.array_spacing_y = value;
      parameters[name] = value;
      break;
    default:
      parameters[name] = value;
      break;
  }
};
